var map = {
	"./HomePage.tsx": [
		256,
		520,
		917,
		256
	],
	"./PaginaCatalogos.tsx": [
		1753,
		19,
		753
	],
	"./PaginaProdutos.tsx": [
		2935,
		520,
		19,
		209,
		467,
		935
	],
	"./PaginaVideos.tsx": [
		5029,
		520,
		19,
		209,
		29
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 7963;
module.exports = webpackAsyncContext;